import { RedditImg } from "app/constants";

const GithubIcon = () => {
  return <img width="24" height="24" src={RedditImg} alt="Coingecko-icon" />;
};

export default GithubIcon;
